import { Th, Tr } from '@chakra-ui/react';

export function Head() {
  return (
    <Tr>
      <Th>Razão Social</Th>
      <Th>Data do pedido</Th>
      <Th>Cód</Th>
      <Th>Descrição</Th>
      <Th>Nfe. Venda</Th>
      <Th>Nfe. Remessa</Th>
      <Th>Ped. Venda</Th>
      <Th>Ped. Compra</Th>
      <Th>Dt. Compra</Th>
      <Th>NCM</Th>
      <Th>Cod. Forn</Th>
      <Th>COR</Th>
      <Th>Quantidade</Th>
      <Th>Valor unitário</Th>
      <Th>Valor total</Th>
      <Th>Desc</Th>
      <Th>Valor líquido</Th>
      <Th>Valor imposto</Th>
      <Th>Total imposto</Th>
      <Th>% Imposto</Th>
      <Th>DIFAL</Th>
      <Th>CEST</Th>
      <Th>Outras Despesas</Th>
      <Th>VLR Sub. NFE</Th>
      <Th>Base ICMS</Th>
      <Th>FCP SP</Th>
    </Tr>
  );
}
